import { useEffect, useState, type ReactNode } from "react";

// Radix Toast + Sonner render portal viewports that differ between server
// (nothing) and client (portal target), which caused React #418/#423 hydration
// errors. Deferring these to a post-mount render eliminates the mismatch
// without any UX change — toasts are only ever triggered client-side.
export default function ClientOnly({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;
  return <>{children}</>;
}